module.exports = "<svg id=\"4d974f66-ac6f-44e7-b696-98443fd7168a\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 49.92 25.31\"><title>bowtie</title><path d=\"M31.62,6.14V5.71a2.17,2.17,0,0,0-2.18-2.17h-9a2.19,2.19,0,0,0-2.2,2.17v.42C11.9,4.17,0,0,0,0V25.31l18.28-5.9v.16a2.19,2.19,0,0,0,2.19,2.2h9a2.18,2.18,0,0,0,2.18-2.2v-.16l18.3,5.9V0S38,4.18,31.62,6.14Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bowtie.svg
// module id = 552
// module chunks = 1